var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flat-pickr',{staticClass:"form-control",attrs:{"config":{
      locale: _vm.Korean,
      mode: _vm.isRange === true ? 'range' : 'single',
      disableMobile: true,
    },"placeholder":_vm.placeholder},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }